// extracted by mini-css-extract-plugin
export var cardIcon = "_r-5";
export var cardIconUnframed = "_r-9";
export var checkboxCard = "_r-0";
export var checkboxCardSelected = "_r-4";
export var disabled = "_r-2";
export var interactive = "_r-1";
export var outerBorder = "_r-3";
export var spacerMedium = "_r-8";
export var spacerSmall = "_r-7";
export var spacerXsmall = "_r-6";